import styled from "styled-components";
import { typography, color, space, layout } from "styled-system";

export const Text = styled.p`
  font-weight: normal;
  ${typography};
  ${color};
  ${space};
  ${layout};
`;
